import { navSections } from "@/mocks/guaNews";

export default function Footer() {
  return (
    <footer className="border-t border-background-200/70 bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-12">
        <div className="grid gap-8 md:grid-cols-[1.3fr_1fr_1fr]">
          <div>
            <a href="#top" className="inline-flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-restaurant-fill text-lg"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-bold text-foreground-950">五1吃瓜</span>
                <span className="mt-0.5 text-[11px] text-foreground-500">今日爆料 · 一手掌握</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-7 text-foreground-600">
              五1吃瓜专注于今日爆料与最新瓜的聚合整理，热门爆料合集持续汇总，助你快速看懂全网热点。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-900">站内导航</h4>
            <ul className="mt-4 space-y-2.5">
              {navSections.map((n) => (
                <li key={n.id}>
                  <a href={`#${n.id}`} className="inline-flex items-center gap-1.5 text-sm text-foreground-600 hover:text-primary-700">
                    <i className={`${n.icon} text-sm text-foreground-400`}></i>
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-900">内容规范</h4>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              站内内容均为公开资讯的整理与汇总，涉及网传信息会明确标注「待核实」。若认为内容有误或涉及侵权，可通过站内反馈与我们联系。
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              {["来源可溯", "同步更新", "合集归档"].map((t) => (
                <span key={t} className="whitespace-nowrap rounded-full bg-background-50 px-3 py-1 text-xs text-foreground-600 ring-1 ring-inset ring-background-200">
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-9 flex flex-col items-center justify-between gap-3 border-t border-background-200/70 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© 2026 五1吃瓜 · 聚合全网公开资讯，仅供信息参考</p>
          <p className="inline-flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-flashlight-line text-primary-600"></i>
            新料持续更新 · 看这一页就够了
          </p>
        </div>
      </div>
    </footer>
  );
}